import { dispatch, state } from '__common/store';
import { ADD_ROOF_POINT, ADD_ROOF_LAST_POINT } from '__editor/googleMapsRoofsSelector/googleMapsRoofsSelectorActions';
import { snapToRoofCorner } from '__editor/googleMapsRoofsSelector/components/advanceRoofSelecting/utils/roofVertexSnapping';

// Snap the drawing point to a nearby existing roof corner (google map only).
function snapPointToExistingRoofCorner(point: pixelPoint): pixelPoint {
  const { roofsSelector: { mapType } } = state();
  if (mapType !== 'google') {
    return point;
  }
  return snapToRoofCorner(point);
}

export function advanceRoofSelectingClick(
  renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer,
  stage: PIXI.Container,
  snapFn: (point: pixelPoint) => pixelPoint = snapPointToExistingRoofCorner,
) {
  if (renderer.plugins && renderer.plugins.interaction.eventData.data !== null) {
    const { advanceRoofSelecting: { enabled, tempPoint } } = state();
    const coords = stage.toLocal(renderer.plugins.interaction.eventData.data.global);
    const pointToAdd = snapFn(tempPoint ? tempPoint : coords);
    if (enabled) {
      dispatch(ADD_ROOF_POINT(pointToAdd));
    }
  }
}

export function advanceRoofSelectingMove(
  renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer,
  stage: PIXI.Container,
  snapFn: (point: pixelPoint) => pixelPoint = snapPointToExistingRoofCorner,
) {
  const { advanceRoofSelecting: { enabled, roofPoints } } = state();
  if (renderer.plugins && renderer.plugins.interaction.eventData.data !== null) {
    const coords = stage.toLocal(renderer.plugins.interaction.eventData.data.global);
    if (enabled && roofPoints.length && coords.x && coords.y) {
      dispatch(ADD_ROOF_LAST_POINT(snapFn(coords)));
    }
  }
}

export function advanceRoofSelectingMoveOutside(clearFunction: Function) {
  clearFunction();
}
